module.exports = __webpack_public_path__ + "img/character01.e7d44519.png";